// The root timeline and open thread share four point-read slots. Waiting work
// is removed on account/conversation disposal before it can issue a request.
let active = 0;
const waiting = [];
function release() { active--; drain(); }

function drain() {
    while (active < 4 && waiting.length) {
        const item = waiting.shift();
        item.signal?.removeEventListener('abort', item.abort);
        if (item.signal?.aborted) { item.abort(); continue; }
        active++;
        Promise.resolve().then(item.run).then(item.resolve, item.reject).finally(release);
    }
}

export function limitMessageRefresh(run, signal) {
    return new Promise((resolve, reject) => {
        const item = {run, resolve, reject, signal};
        item.abort = () => {
            const index = waiting.indexOf(item);
            if (index >= 0) waiting.splice(index, 1);
            reject(signal?.reason || new DOMException('Canceled', 'AbortError'));
        };
        if (signal?.aborted) { item.abort(); return; }
        signal?.addEventListener('abort', item.abort, {once: true});
        waiting.push(item);
        drain();
    });
}
